import { FloatingToolbar } from '@st/document-viewer-kit'
import clsx from 'clsx'
import { ReactNode } from 'react'

export function AnnotationFloatingToolbar({ children }: { children: ReactNode }) {
  return (
    <FloatingToolbar className="flex flex-row rounded-sm bg-black text-white">
      {children}
    </FloatingToolbar>
  )
}

type FloatingToolbarButtonProps = {
  onClick?: () => void
  disabled?: boolean
  icon: ReactNode
}
export function FloatingToolbarButton({ icon, onClick, disabled }: FloatingToolbarButtonProps) {
  return (
    <button
      className={clsx('flex size-8 items-center justify-center bg-transparent disabled:opacity-50')}
      disabled={disabled}
      onPointerDown={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onClick?.()
      }}
    >
      {icon}
    </button>
  )
}
